'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pathStringToBind = exports.FirebindToApp = exports.Firebind = exports.NEVER = exports.WAITING = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

exports.resolveBindConfig = resolveBindConfig;
exports.resolvePropMap = resolvePropMap;
exports.firebind = firebind;
exports.firebindToApp = firebindToApp;

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _lodash = require('lodash');

var _FirebaseProvider = require('./FirebaseProvider');

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/*
  GLOSSARY
  outer prop - a prop given to the HOC-wrapped component
  inner prop - a prop that for the wrapped component or render prop
  [unresolved] prop map - the user-defined mapping of inner props to configurations
  resolved prop map - the normalised version of the prop map, mapping inner props to database binds
  config (EndpointPropConfig) - a user-friendly
  bind (DatabaseBind) - an actionable static definition of a firebase query
*/


var WAITING = exports.WAITING = Symbol('Waiting for load');
var NEVER = exports.NEVER = Symbol('Will never load');
console.log('Welcome to firebind.js');

var UnwrappedFirebind = function (_React$Component) {
  _inherits(UnwrappedFirebind, _React$Component); // bindings are a collection of unsubscribe triggers


  function UnwrappedFirebind(props) {
    _classCallCheck(this, UnwrappedFirebind);

    var _this = _possibleConstructorReturn(this, (UnwrappedFirebind.__proto__ || Object.getPrototypeOf(UnwrappedFirebind)).call(this, props));

    _initialiseProps.call(_this);

    _this.state = _this.stateForProps({}, props, _this.state);
    return _this;
  }

  _createClass(UnwrappedFirebind, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(oldProps) {
      var state = this.stateForProps(oldProps, this.props, this.state);

      if (state !== this.state) {
        this.setState(function () {
          return state;
        });
      }
    }
  }, {
    key: 'stateForProps',
    value: function stateForProps(oldProps) {
      var _this2 = this;

      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props;
      var oldState = arguments[2];

      if (!props.firebaseApp || !props.firebaseApp.controller) {
        throw new Error('Couldn\'t find firebase app controller in context');
      }

      var bind = props.bind,
          controller = props.firebaseApp.controller,
          whileLoading = props.whileLoading,
          using = _objectWithoutProperties(props, ['bind', 'firebaseApp', 'whileLoading']);

      var values = oldState.values,
          bindings = oldState.bindings,
          resolvedPropMap = oldState.resolvedPropMap;
      var oldResolvedPropMap = resolvedPropMap;
      resolvedPropMap = resolvePropMap(_extends({}, using, values), bind); // console.log('Resolved Prop Map', resolvedPropMap)

      if ((0, _lodash.isEqual)(oldResolvedPropMap, resolvedPropMap)) {
        return oldState;
      } // Unbind subscriptions where the binding definition has changed


      (0, _lodash.forEach)(oldResolvedPropMap, function (oldBind, propName) {
        if (!(0, _lodash.isEqual)(oldBind, resolvedPropMap[propName])) {
          bindings[propName] && bindings[propName]();
        }
      });

      var state = _extends({}, oldState, {
        resolvedPropMap: resolvedPropMap // create new bindings where they're different or new

      });

      (0, _lodash.forEach)(resolvedPropMap, function (newBind, propName) {
        if (!(0, _lodash.isEqual)(oldResolvedPropMap[propName], newBind)) {
          if (newBind === NEVER) {
            console.log(propName + ' has been marked as unresolvable');
            return;
          }

          state.loadingProps = _extends({}, state.loadingProps, _defineProperty({}, propName, true));

          if (newBind === WAITING) {
            return;
          }

          var _controller$listen = controller.listen(newBind, function (value) {
            return _this2.handleChange(propName, value);
          }),
              value = _controller$listen.value,
              _loading = _controller$listen.loading,
              unsubscribe = _controller$listen.unsubscribe;

          if (!_loading) {
            state = _this2.stateForChange(props, state, propName, value);
          }

          state.bindings = _extends({}, state.bindings, _defineProperty({}, propName, unsubscribe));
        }
      });
      state.loading = (0, _lodash.some)(props.bind, function (_, propName) {
        return state.loadingProps[propName];
      });
      return state;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unsubscribe();
    }
  }, {
    key: 'unsubscribe',
    value: function unsubscribe() {
      (0, _lodash.forEach)(this.state.bindings, function (unsubscribe) {
        return unsubscribe && unsubscribe();
      });
      this.setState({
        bindings: {}
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          values = _state.values,
          loading = _state.loading;
      var _props = this.props,
          children = _props.children,
          whileLoading = _props.whileLoading;

      if (!(0, _lodash.isUndefined)(whileLoading) && loading) {
        return whileLoading;
      }

      return children(values, !!loading);
    }
  }]);

  return UnwrappedFirebind;
}(React.Component);

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.state = {
    values: {},
    bindings: {},
    loading: true,
    loadingProps: {},
    resolvedPropMap: {}
  };

  this.stateForChange = function (props, state, propName, value) {
    var values = _extends({}, state.values, _defineProperty({}, propName, value));

    var loadingProps = _extends({}, state.loadingProps, _defineProperty({}, propName, false));

    return _extends({}, state, {
      values: values,
      loadingProps: loadingProps,
      loading: (0, _lodash.some)(props.bind, function (_, propName) {
        return loadingProps[propName];
      })
    });
  };

  this.handleChange = function (propName, value) {
    _this3.setState(function (state) {
      return _this3.stateForChange(_this3.props, state, propName, value);
    });
  };
};

var Firebind = exports.Firebind = (0, _FirebaseProvider.withFirebaseApp)(UnwrappedFirebind);
var FirebindToApp = exports.FirebindToApp = UnwrappedFirebind;

var pathStringToBind = exports.pathStringToBind = function pathStringToBind(ref) {
  return {
    ref: ref
  };
};

function resolveBindConfig(props, config) {
  var databaseBind = void 0;

  if (typeof config === 'string') {
    databaseBind = pathStringToBind(config);
  } else if (typeof config === 'function') {
    var result = config(props);

    if (typeof result === 'string') {
      databaseBind = pathStringToBind(result);
    } else {
      databaseBind = result;
    }
  } else {
    databaseBind = config;
  }

  var bindIsObject = (0, _lodash.isPlainObject)(databaseBind);

  if (bindIsObject) {
    /* FlowFixMe */
    if ((0, _lodash.isString)(databaseBind.ref)) {
      return databaseBind;
    } else {
      if (databaseBind.optional) {
        return NEVER;
      }
    }
  }

  return WAITING;
}

function resolvePropMap(props, propMap) {
  return (0, _lodash.mapValues)(propMap, function (config) {
    return resolveBindConfig(props, config);
  });
}

function firebind(Component, propMap) {
  var FirebindHOC = function FirebindHOC(outerProps) {
    return React.createElement(Firebind, _extends({
      bind: propMap
    }, outerProps), function (innerProps, loading) {
      return React.createElement(Component, _extends({}, outerProps, innerProps, {
        loading: !!(outerProps.loading || loading)
      }));
    });
  };

  return FirebindHOC;
}

function firebindToApp(Component, propMap, firebaseApp) {
  var FirebindHOC = function FirebindHOC(outerProps) {
    return React.createElement(FirebindToApp, _extends({
      firebaseApp: firebaseApp,
      bind: propMap
    }, outerProps), function (innerProps, loading) {
      return React.createElement(Component, _extends({}, outerProps, innerProps, {
        loading: !!(outerProps.loading || loading)
      }));
    });
  };

  return FirebindHOC;
}